import type { LayoutDocument } from '../layout/types'

/** Whether a kiosk design opens on its welcome screen; one set to skip it opens on its menu. */
export function startsAtWelcome(doc: Pick<LayoutDocument, 'canvas'> | null | undefined): boolean {
  return doc?.canvas.skipWelcome !== true
}

/** Where the kiosk returns after a ticket, an idle wait or Back from the menu: its start, in the first language. */
export function kioskStart(welcome: boolean, firstLanguage: string): { screen: { at: 'attract' } | { at: 'choosing' }; lang: string } {
  return { screen: welcome ? { at: 'attract' } : { at: 'choosing' }, lang: firstLanguage }
}

/** What a language switch offers: every customer language but the one showing, in order. One language offers none. */
export function otherLanguages(codes: readonly string[], showing: string): string[] {
  return codes.length <= 1 ? [] : codes.filter((code) => code !== showing)
}

/** A language switch's label: the code, compact and the same in every language. */
export function switchLabel(code: string): string {
  return code.toUpperCase()
}

/**
 * Whether a kiosk stands as it starts, with nothing for its idle wait to undo:
 * the welcome screen, or with no welcome, the menu in the first language.
 */
export function atRest(
  screen: { at: string; page?: string; trail?: readonly string[] },
  lang: string,
  firstLanguage: string,
  welcome: boolean,
  menuPage: string,
): boolean {
  if (welcome) return screen.at === 'attract'
  return (
    screen.at === 'choosing' &&
    (screen.page === undefined || screen.page === menuPage) &&
    (screen.trail?.length ?? 0) === 0 &&
    lang === firstLanguage
  )
}
